<template>

    <kt-modal
        :visible="recordVisible"
        :title="recordTitle"
        @dismiss="onDismiss()"
    >
        <template #body>
            <tech-form 
                v-model="record"
            ></tech-form>
        </template>
    
        <template #footer>
            <div class="row w-100">
                <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                    <button @click="onDismiss()" class="btn btn-sm btn-outline-secondary form-control">Close</button>
                </div>
                <div class="col-4" v-if="record.Id">
                    <button @click="deleteRecord()" class="btn btn-sm btn-outline-danger form-control">Delete</button>
                </div>
                <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                    <button @click="saveRecord()" class="btn btn-sm btn-outline-primary form-control">Save</button>
                </div>
            </div>
        </template>
    </kt-modal>
        
    </template>
    
    <script lang="ts" setup>
    
    import { ref, onMounted, onUpdated } from "vue";
    import { useRoute, useRouter } from "vue-router";
    import Api from "@/services/ApiService";
    import TechForm from "@/components/Techs/TechForm.vue";
    import { TechnicianModel } from "@/models/TechnicianModel";
    import KtModal from "@/components/UI/KtModal.vue";
    import Alert from "@/services/Alert";
    import { useTechStore } from "@/stores/TechStore";
    
    const route = useRoute();
    const router = useRouter();
    const recordTitle = ref("Tech Entry");
    const recordVisible = ref(true);
    
    const newRecord = () =>
    {
        return new TechnicianModel();
    };
    
    const record = ref(newRecord());
    
    const saveRecord = async () =>
    {
        if (!record.value.TechnicianName)
        {
            Alert.notify({
                text:"Please enter a technician name"
            });
            return;
        }

        if (!record.value.Email)
        {
            Alert.notify({
                text: "Please enter an email address"
            });
            return;
        }

        let pay = record.value;
        await Api.saveTech(pay);

        let techs = useTechStore();
        await techs.reload();

        router.push({
            path: "/tech/list"
        });
    };
    
    const deleteRecord = async () =>
    {
        Alert.notify({
            text: "Deletion is currently disabled"
        });
    };
    
    
    const onDismiss = () =>
    {
        router.push({
            path: "/tech/list"
        });
    };

    const loadRecord = async () =>
    {
        switch (route.params.id)
        {
            case "new":
                record.value = newRecord();
                break;
    
            default:
                let rec = await Api.loadTech(Number(route.params.id));
                record.value = rec;
                break;
        }
    };

    
    /*
    onUpdated(async () =>
    {
        loadRecord();
    });
    */

    onMounted(() =>
    {
        loadRecord();
    });
    
</script>